import PartyTarget from "../../../model/character/PartyTarget";
import Totals from "../../../model/crew/Totals";
import Statistics from "../../../model/statistics/Statistics";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import RowContainerTitle from "./RowContainerTitle";
import RowContainerLayerProgress from "./RowContainerLayerProgress";

export default class RowContainerPanel extends ParentView {
    /**
     * @param {string} parentId
     * @param {Totals} totals
     * @param {PartyTarget} partyTarget
     * @param {Statistics} statistics
     */
    constructor(parentId, totals, partyTarget, statistics) {
        super(parentId, parentId + '_panel');

        this.addView(new RowContainerTitle(this.elementId, totals));

        this.addView(new RowContainerLayerProgress(this.elementId, partyTarget, statistics));
    }

    /**
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'top-row-panel');

        super.initializeView();
    }
}